import React from 'react';
import { Route } from 'react-router-dom';
import SummaryPageRoute from './SummaryPageRoute';

const basePath = '/v2/summary';

export default (
  <Route path={`${basePath}/:summaryId`}>
    <SummaryPageRoute />
  </Route>
);
